"use client";

import type { Control } from "react-hook-form";
import type { CustomerServiceFormData } from "./customer-service-form.schema";

import { Checkbox } from "@homeinstead/ui/components/Checkbox";
import { Link } from "@homeinstead/ui/components/Link";
import { Controller } from "react-hook-form";

type CustomerServiceSmsConsentProps = {
  control: Control<CustomerServiceFormData>;
  disabled?: boolean;
};

function CustomerServiceSmsConsent({
  control,
  disabled,
}: CustomerServiceSmsConsentProps) {
  return (
    <Controller
      control={control}
      name="smsConsent"
      render={({ field }) => (
        <label className="group flex cursor-pointer items-start gap-3 has-[:disabled]:cursor-not-allowed">
          <div className="mt-0.5 shrink-0">
            <Checkbox
              checked={field.value}
              disabled={disabled}
              id="smsConsent"
              name={field.name}
              onChange={field.onChange}
            />
          </div>
          <span className="text-new-beginnings-base text-sm leading-snug">
            By checking this box, I consent to receive automated SMS text
            messages from Home Instead at the phone number provided related to
            my inquiry, service-related updates, account notifications, job
            opportunities, marketing, and other important communications.
            Message frequency may vary. Message &amp; data rates may apply.
            Reply STOP to opt out. For assistance, text &ldquo;HELP&rdquo;. Your
            consent is not required to submit this form. For more details,
            including our SMS terms, see our{" "}
            <Link
              className="text-sm underline hover:no-underline"
              href="https://www.homeinstead.com/legal/privacy-policy"
              size="inline"
              target="_blank"
              variant="plain"
            >
              Privacy Policy
            </Link>
            .
          </span>
        </label>
      )}
    />
  );
}

export { CustomerServiceSmsConsent };
